export class StateUrlCache {
    private static instance: StateUrlCache;

    url: string;

    static getInstance() {
        if (!StateUrlCache.instance) {
            StateUrlCache.instance = new StateUrlCache();
        }

        return StateUrlCache.instance;
    }

    constructor() {
        this.url = '';
    }

    setUrl(href: string) {
        let index = href.indexOf('#');
        this.url = href.slice(index+1, href.length);
    }
}
